import React from 'react'
// Ant Design
import { Flex, Typography, Avatar, Skeleton, Pagination } from 'antd'
// Ant Design Icons
import { CaretRightOutlined } from '@ant-design/icons'
// Config
import { getConfig } from '../../config'
const { Text  } = Typography

export const ContentUsers = ({ select, data, loading, setSelect, page, setPage, total }) => {

    function Loading() {
        return (
            <Flex className="skin-scroll" vertical style={{ width: "40%", height: "calc(100vh - 70px)", overflowY: "auto", borderRight: `2px solid ${getConfig("colorPrimario")}` }}>
                <Flex align="center" style={{ width: "100%", padding: "20px 0" }}>
                    <Skeleton.Avatar active size={40} style={{ marginRight: "10px" }} />
                    <Skeleton.Input active />
                </Flex>
                <Flex align="center" style={{ width: "100%", padding: "20px 0" }}>
                    <Skeleton.Avatar active size={40} style={{ marginRight: "10px" }} />
                    <Skeleton.Input active />
                </Flex>
                <Flex align="center" style={{ width: "100%", padding: "20px 0" }}>
                    <Skeleton.Avatar active size={40} style={{ marginRight: "10px" }} />
                    <Skeleton.Input active />
                </Flex>
                <Flex align="center" style={{ width: "100%", padding: "20px 0" }}>
                    <Skeleton.Avatar active size={40} style={{ marginRight: "10px" }} />
                    <Skeleton.Input active />
                </Flex>
                <Flex align="center" style={{ width: "100%", padding: "20px 0" }}>
                    <Skeleton.Avatar active size={40} style={{ marginRight: "10px" }} />
                    <Skeleton.Input active />
                </Flex>
                <Flex align="center" style={{ width: "100%", padding: "20px 0" }}>
                    <Skeleton.Avatar active size={40} style={{ marginRight: "10px" }} />
                    <Skeleton.Input active />
                </Flex>
                <Flex align="center" style={{ width: "100%", padding: "20px 0" }}>
                    <Skeleton.Avatar active size={40} style={{ marginRight: "10px" }} />
                    <Skeleton.Input active />
                </Flex>
            </Flex>
        )
    }

    function Users() {
        const firstLetter = (name) => name.charAt(0).toUpperCase()

        function hexToRgba(hex, opacity = 0.2) {
            hex = hex.replace(/^#/, '');
        
            let r = parseInt(hex.substring(0, 2), 16);
            let g = parseInt(hex.substring(2, 4), 16);
            let b = parseInt(hex.substring(4, 6), 16);
        
            return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        }

        return (
            <Flex className="skin-scroll" vertical style={{ position: "relative", width: "30%", height: "calc(100vh - 70px)", overflowY: "auto", borderRight: `2px solid ${getConfig("colorPrimario")}` }}>
                {data.map((Item, index) => (
                    <Flex key={index+1} onClick={() => setSelect(Item)} justify="space-between" align="center" style={{ minHeight: "80px", paddingRight: "10px", cursor: "pointer", boxShadow: (select && select._id === Item._id) && "0px 6px 12px rgba(0, 0, 0, 0.2)", transition: "box-shadow 0.3s ease" }}>
                        <Flex align="center">
                            <Avatar size={40} style={{ marginRight: "10px", backgroundColor: hexToRgba(getConfig("colorSecundario")), color: getConfig("colorSecundario") }}>{firstLetter(Item.full_name)}</Avatar>
                            <Text style={{ fontSize: "15px", fontWeight: "400" }}>{Item.full_name}</Text>
                        </Flex>
                        <CaretRightOutlined style={{ color: getConfig("colorSecundario"), fontSize: "20px" }} />
                    </Flex>
                ))}

                <Flex justify="center" style={{ position: "sticky", width: "100%", bottom: "0px", left: 0, backgroundColor: "#fff", zIndex: "1" }}>
                    <Pagination
                        simple={{ readOnly: true }}
                        current={page} 
                        onChange={(newPage) => setPage(newPage)} 
                        total={total}
                        pageSize={10}
                        showSizeChanger={false}
                    />
                </Flex>
            </Flex>
        )
    }

    return loading ? <Loading /> : <Users />
}
